// Code generated. DO NOT EDIT.

const builtinFunctions: string[] = [
  'agg.make_set',
  'agg.count',
  'agg.count_distinct',
  'agg.avg',
  'agg.max',
  'agg.min',
  'agg.sum',
  'agg.take_any',
  'agg.stddev',
  'agg.percentile_cont',
  'toscalar',
  'time.ago',
  'time.now',
  'time.add',
  'time.diff',
  'time.trunc',
  'time.slice',
  'time.parse_timespan',
  'time.parse_timestamp',
  'strings.cat',
  'strings.len',
  'strings.contains',
  'strings.starts_with',
  'strings.ends_with',
  'strings.like',
  'strings.ilike',
  'strings.split',
  'strings.lower',
  'strings.upper',
  'strings.join',
  'arrays.len',
  'arrays.overlap',
  'arrays.sort',
  'arrays.intersection',
  'arrays.union',
  'arrays.difference',
  'coalesce',
  'math.round',
  'math.floor',
  'math.ceil',
  'math.abs',
  'case',
  'panther',
  'object',
  'array',
  're.matches',
  're.count',
  're.substr',
  're.replace',
  'snowflake.func',
  'databricks.func',
  'arrays.map',
  'arrays.filter',
  'arrays.flatten',
];

export { builtinFunctions };
